module.exports = __webpack_public_path__ + "static/img/m_1.3eb2ab5e.jpg";